import React from 'react';

import { Grid, Typography, Chip, Section } from '@gogame/components';
import { withForm, SidePageV2 } from '@gogame/form';

import { loadUsers } from 'scenes/Campaigns/sources/fields';

import { OwnerItem } from '../Owners/OwnerItem';
import { CAMPAIGN_IDS, CAMPAIGN_NAMES } from '../constants';
import { ownerSchema } from './schema';

export const ChangeOwnerForm = withForm({
  enableReinitialize: true,
  validationSchema: ownerSchema,
})(({ values, onClose, loading, minDate, count, onExited, open }) => {
  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
    >
      <SidePageV2.Title
        title={'Change Owner'}
        subTitle={`Campaigns (${
          values[CAMPAIGN_IDS].length ? values[CAMPAIGN_IDS].length : count
        })`}
      />
      <SidePageV2.Content>
        <Section>
          <OwnerItem
            min={minDate}
            onLoadOwners={loadUsers}
            withRemove={false}
          />
        </Section>
        <Section>
          <Typography intensity={200}>
            Selected: {values[CAMPAIGN_IDS].length ? '' : `${count} campaigns`}
          </Typography>
          {values[CAMPAIGN_IDS].length ? (
            <Grid container>
              {values[CAMPAIGN_NAMES].map((name, index) => (
                <Grid item key={index}>
                  <Chip label={name} variant={'outlined'} />
                </Grid>
              ))}
            </Grid>
          ) : null}
        </Section>
      </SidePageV2.Content>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton disabled={loading} />
      </SidePageV2.Actions>
    </SidePageV2>
  );
});
